<div class="other-layout-flex-content">
  <router-outlet></router-outlet>
  <ngx-spinner [fullScreen]="true" name="other-layout-spinner" size="default"
               type="line-spin-clockwise-fade"></ngx-spinner>
</div>
